var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-row', {
    staticClass: "row--large",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "auto"
    }
  }, [_c('v-card', {
    staticClass: "join-gate-box",
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "w-100 pa-20 pa-md-30 pa-lg-60 join-gate-box__inner"
  }, [_c('div', {
    staticClass: "join-gate-box__icon mb-16 mb-lg-24"
  }, [_c('i', {
    staticClass: "icon icon-user"
  })]), _c('h5', {
    staticClass: "tit tit--sm mb-4 mb-lg-8"
  }, [_vm._v("개인회원")]), _c('p', {
    staticClass: "page-text mb-18 mb-lg-32"
  }, [_vm._v(" 개인회원가입 관련 한 줄 문구가 입력됩니다. ")]), _c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('input', _vm.USER_TYPES.PERSON.value);
      }
    }
  }, [_vm._v("개인회원가입")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "auto"
    }
  }, [_c('v-card', {
    staticClass: "join-gate-box",
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "w-100 pa-20 pa-md-30 pa-lg-60 join-gate-box__inner"
  }, [_c('div', {
    staticClass: "join-gate-box__icon mb-16 mb-lg-24"
  }, [_c('i', {
    staticClass: "icon icon-company"
  })]), _c('h5', {
    staticClass: "tit tit--sm mb-4 mb-lg-8"
  }, [_vm._v("기업회원")]), _c('p', {
    staticClass: "page-text mb-18 mb-lg-32"
  }, [_vm._v(" 기업회원가입 관련 한 줄 문구가 입력됩니다. ")]), _c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('input', _vm.USER_TYPES.COMPANY.value);
      }
    }
  }, [_vm._v("기업회원가입")])], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }